import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./AddNewPatient.module.css"
import AddPatient from "@components/AddNewPatientPage/AddPatient"

function AddNewPatientPage() {
  return (
    <NavigationsPage>
      <PageWrapper className={styles.manageAppointmentPage}>
        <AddPatient />
      </PageWrapper>
    </NavigationsPage>
  )
}

export default AddNewPatientPage
